import type { HubCategory, HubVisualVariant } from "./notificationTypes.ts";

export type RegistryEntry = {
  category: HubCategory;
  variant: HubVisualVariant;
  titleTemplate: string;
  bodyTemplate: string;
  emailOnCreate: boolean;
};

const E = (partial: RegistryEntry): RegistryEntry => partial;

export const NOTIFICATION_REGISTRY: Record<string, RegistryEntry> = {
  COMMENT_ENVIADO: E({
    category: "projects",
    variant: "info",
    titleTemplate: "Pregunta en tu proyecto",
    bodyTemplate: "{{actor}} dejó una pregunta en tu proyecto.",
    emailOnCreate: false,
  }),
  USER_COMMENT_ENVIADO: E({
    category: "projects",
    variant: "info",
    titleTemplate: "Pregunta en tu proyecto",
    bodyTemplate: "{{actor}} dejó una pregunta en tu proyecto.",
    emailOnCreate: false,
  }),
  COMMENT_RESPONDIDO: E({
    category: "projects",
    variant: "default",
    titleTemplate: "Respondieron tu pregunta",
    bodyTemplate: "{{actor}} respondió tu comentario en el proyecto.",
    emailOnCreate: false,
  }),
  USER_COMMENT_RESPONDIDO: E({
    category: "projects",
    variant: "default",
    titleTemplate: "Respondieron tu pregunta",
    bodyTemplate: "{{actor}} respondió tu comentario en el proyecto.",
    emailOnCreate: false,
  }),
  POSTULACION_SEND: E({
    category: "projects",
    variant: "info",
    titleTemplate: "Nueva postulación",
    bodyTemplate: "{{actor}} se postuló a tu proyecto.",
    emailOnCreate: true,
  }),
  POSTULACION_ACCEPTED: E({
    category: "projects",
    variant: "success",
    titleTemplate: "Postulación aceptada",
    bodyTemplate: "Tu postulación al proyecto fue aceptada.",
    emailOnCreate: true,
  }),
  POSTULACION_NEGATED: E({
    category: "projects",
    variant: "warning",
    titleTemplate: "Postulación rechazada",
    bodyTemplate: "Tu postulación al proyecto fue rechazada.",
    emailOnCreate: false,
  }),
  PRESUPUESTO_ENVIADO: E({
    category: "projects",
    variant: "info",
    titleTemplate: "Presupuesto recibido",
    bodyTemplate: "{{actor}} envió un presupuesto para un rubro de tu obra.",
    emailOnCreate: true,
  }),
  PRESUPUESTO_ACEPTADO: E({
    category: "projects",
    variant: "success",
    titleTemplate: "Presupuesto aceptado",
    bodyTemplate: "El dueño de la obra aceptó tu presupuesto.",
    emailOnCreate: false,
  }),
  PRESUPUESTO_NEGADO: E({
    category: "projects",
    variant: "warning",
    titleTemplate: "Presupuesto rechazado",
    bodyTemplate: "El dueño de la obra rechazó tu presupuesto.",
    emailOnCreate: false,
  }),
  QUOTATION_SEND: E({
    category: "materials",
    variant: "info",
    titleTemplate: "Cotización de materiales",
    bodyTemplate:
      "{{actor}} te envió un presupuesto de materiales para un pedido de cotización.",
    emailOnCreate: true,
  }),
  QUOTATION_MATERIALS_UPDATED: E({
    category: "materials",
    variant: "info",
    titleTemplate: "Materiales actualizados",
    bodyTemplate:
      "{{actor}} actualizó la oferta de materiales de un pedido en el que participás; revisá el presupuesto.",
    emailOnCreate: true,
  }),
  USER_POSTULATION_SEND: E({
    category: "account",
    variant: "info",
    titleTemplate: "Solicitud de registro",
    bodyTemplate: "{{actor}} solicitó acceso a la plataforma.",
    emailOnCreate: true,
  }),
  USER_FEATURED_POSTULATION_SEND: E({
    category: "account",
    variant: "info",
    titleTemplate: "Postulación destacada",
    bodyTemplate: "{{actor}} envió una postulación destacada.",
    emailOnCreate: true,
  }),
  USER_POSTULATION_ACCEPTED: E({
    category: "account",
    variant: "success",
    titleTemplate: "Postulación destacada aceptada",
    bodyTemplate: "Tu postulación destacada fue aceptada.",
    emailOnCreate: true,
  }),
  USER_POSTULATION_NEGATED: E({
    category: "account",
    variant: "warning",
    titleTemplate: "Postulación destacada rechazada",
    bodyTemplate: "Tu postulación destacada fue rechazada.",
    emailOnCreate: true,
  }),
  NEW_PROFILE_VIEW: E({
    category: "social",
    variant: "default",
    titleTemplate: "Visita a tu perfil",
    bodyTemplate: "{{actor}} visitó tu perfil.",
    emailOnCreate: false,
  }),
  USER_NEW_PROFILE_VIEW: E({
    category: "social",
    variant: "default",
    titleTemplate: "Visita a tu perfil",
    bodyTemplate: "{{actor}} visitó tu perfil.",
    emailOnCreate: false,
  }),
  NEW_PROFILE_REVIEW: E({
    category: "social",
    variant: "success",
    titleTemplate: "Nueva calificación",
    bodyTemplate: "{{actor}} te dejó una calificación en tu perfil.",
    emailOnCreate: false,
  }),
  POST_LIKE_SEND: E({
    category: "social",
    variant: "default",
    titleTemplate: "Me gusta en tu publicación",
    bodyTemplate: "{{actor}} le dio me gusta a tu publicación.",
    emailOnCreate: false,
  }),
  POST_COMMENT_SEND: E({
    category: "social",
    variant: "info",
    titleTemplate: "Comentario en tu publicación",
    bodyTemplate: "{{actor}} comentó tu publicación.",
    emailOnCreate: false,
  }),
  POST_COMMENT_LIKE: E({
    category: "social",
    variant: "default",
    titleTemplate: "Me gusta en tu comentario",
    bodyTemplate: "{{actor}} le dio me gusta a tu comentario.",
    emailOnCreate: false,
  }),
  POST_COMMENT_RESPONSE: E({
    category: "social",
    variant: "info",
    titleTemplate: "Respuesta a tu comentario",
    bodyTemplate: "{{actor}} respondió tu comentario.",
    emailOnCreate: false,
  }),
  NEW_CONTACT_REQUEST: E({
    category: "work",
    variant: "info",
    titleTemplate: "Solicitud de contacto",
    bodyTemplate: "{{actor}} quiere contactarte.",
    emailOnCreate: true,
  }),
  NEW_COINCIDENCES: E({
    category: "work",
    variant: "info",
    titleTemplate: "Coincidencia de obra",
    bodyTemplate:
      "{{actor}} publicó una obra que coincide con tu rubro. Revisá los detalles y postuláte.",
    emailOnCreate: true,
  }),
  NEW_JOB_APLICATION: E({
    category: "work",
    variant: "info",
    titleTemplate: "Postulación laboral",
    bodyTemplate: "{{actor}} se postuló a tu aviso de trabajo.",
    emailOnCreate: true,
  }),
  NEW_QUESTION: E({
    category: "portfolio",
    variant: "info",
    titleTemplate: "Pregunta en tu portfolio",
    bodyTemplate: "Recibiste una nueva pregunta sobre tu portfolio.",
    emailOnCreate: true,
  }),
  QUESTION_RESPONDIDO: E({
    category: "portfolio",
    variant: "default",
    titleTemplate: "Respuesta en tu consulta",
    bodyTemplate: "{{actor}} respondió tu pregunta del portfolio.",
    emailOnCreate: true,
  }),
  MATERIAL_DEMAND_ALERT: E({
    category: "materials",
    variant: "warning",
    titleTemplate: "Demanda de materiales",
    bodyTemplate: "Hay demanda de materiales que coinciden con tu comercio.",
    emailOnCreate: false,
  }),
  MATERIAL_DEMAND_ALERT_GENERIC: E({
    category: "materials",
    variant: "warning",
    titleTemplate: "Demanda de materiales",
    bodyTemplate:
      "Hay una demanda de materiales relevante para tu perfil y tu jurisdicción.",
    emailOnCreate: false,
  }),
  CATEGORY_CONNECT_ACTIVITY: E({
    category: "social",
    variant: "info",
    titleTemplate: "Actividad en tus categorías de interés",
    bodyTemplate:
      "{{actor}} tiene actividad nueva alineada a las categorías que seguís.",
    emailOnCreate: true,
  }),
  COMMENT_RECIBIDO: E({
    category: "projects",
    variant: "default",
    titleTemplate: "Comentario recibido",
    bodyTemplate: "Notificación de comentario (tipo reservado).",
    emailOnCreate: false,
  }),
  QUOTATION_ACCEPTED: E({
    category: "materials",
    variant: "success",
    titleTemplate: "Cotización aceptada",
    bodyTemplate: "Notificación de cotización aceptada (tipo reservado).",
    emailOnCreate: false,
  }),
  QUOTATION_UPDATE: E({
    category: "materials",
    variant: "info",
    titleTemplate: "Actualización de cotización",
    bodyTemplate: "Notificación de actualización de cotización (tipo reservado).",
    emailOnCreate: false,
  }),
};

const FALLBACK_ENTRY: RegistryEntry = {
  category: "system",
  variant: "default",
  titleTemplate: "Notificación",
  bodyTemplate: "{{actor}} generó una actividad en la plataforma.",
  emailOnCreate: false,
};

export function getRegistryEntry(type: string | undefined): RegistryEntry {
  if (!type) return FALLBACK_ENTRY;
  return NOTIFICATION_REGISTRY[type] ?? FALLBACK_ENTRY;
}
